import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, SelectMenu } from '@livable/saas-react-components';
import { Chip, Grid, MenuItem, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { events, track } from 'src/configs/amplitude';
import { UNIT_STATUSES_NAMED } from 'src/constants/unit';
import { useStore } from 'src/stores';
import useEnrollInStyles2 from './styles';
// import { toJS } from 'mobx';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
export const EnrollIn = observer(_ref => {
  var _currentCompany$portf, _currentCompany$portf2, _currentCompany$portf5, _getProperties, _getProperties2, _getProperties3;
  let propertyId = _ref.propertyId,
    selectedUnit = _ref.selectedUnit,
    setActiveUnitName = _ref.setActiveUnitName,
    setSelectedUnit = _ref.setSelectedUnit,
    enablePortfolioSelect = _ref.enablePortfolioSelect,
    portfolioId = _ref.portfolioId,
    newBillingActivated = _ref.newBillingActivated;
  const classes = useEnrollInStyles2();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const currentCompany = store.homeDashboardStore.getCurrentCompany;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    portfolioSearchKey = _useState2[0],
    setPortfolioSearchKey = _useState2[1];
  const _useState3 = useState(currentCompany !== null && currentCompany !== void 0 && (_currentCompany$portf = currentCompany.portfolios) !== null && _currentCompany$portf !== void 0 && _currentCompany$portf.length ? portfolioId || ((_currentCompany$portf2 = currentCompany.portfolios) === null || _currentCompany$portf2 === void 0 || (_currentCompany$portf2 = _currentCompany$portf2.find(portfolio => {
      var _portfolio$properties;
      return !!(portfolio !== null && portfolio !== void 0 && (_portfolio$properties = portfolio.properties.filter(property => (property === null || property === void 0 ? void 0 : property.propertyStatus) === PROPERTY_STATUS_ENUM.Active)) !== null && _portfolio$properties !== void 0 && _portfolio$properties.length);
    })) === null || _currentCompany$portf2 === void 0 ? void 0 : _currentCompany$portf2.id) : null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPortfolio = _useState4[0],
    setSelectedPortfolio = _useState4[1];
  const customSearchedUnits = store.enrollResident.customSearchedUnits.filter(i => i.status === UNIT_STATUSES_NAMED.ToBeVacantSoon || i.status === UNIT_STATUSES_NAMED.Vacant);
  const getUnitsExtendedAsync = store.units.getUnitsExtendedAsync;
  const initialUnits = store.enrollResident.searchedUnitsData.filter(i => i.status === UNIT_STATUSES_NAMED.ToBeVacantSoon || i.status === UNIT_STATUSES_NAMED.Vacant);
  const getUnits = async id => {
    const respExtend = await getUnitsExtendedAsync.run({
      propertyId: id,
      statuses: [UNIT_STATUSES_NAMED.Vacant, UNIT_STATUSES_NAMED.ToBeVacantSoon],
      search: ''
    });
    return respExtend;
  };
  const getProperties = () => {
    var _ref2, _currentCompany$portf3, _currentCompany$portf4;
    return ((_ref2 = (currentCompany === null || currentCompany === void 0 || (_currentCompany$portf3 = currentCompany.portfolios) === null || _currentCompany$portf3 === void 0 || (_currentCompany$portf3 = _currentCompany$portf3.find(portfolio => portfolio.id === selectedPortfolio)) === null || _currentCompany$portf3 === void 0 ? void 0 : _currentCompany$portf3.properties) || (currentCompany === null || currentCompany === void 0 || (_currentCompany$portf4 = currentCompany.portfolios) === null || _currentCompany$portf4 === void 0 ? void 0 : _currentCompany$portf4.find(portfolio => {
      var _portfolio$properties2;
      return !!((_portfolio$properties2 = portfolio.properties.filter(property => (property === null || property === void 0 ? void 0 : property.propertyStatus) === PROPERTY_STATUS_ENUM.Active)) !== null && _portfolio$properties2 !== void 0 && _portfolio$properties2.length);
    }).properties)) === null || _ref2 === void 0 ? void 0 : _ref2.filter(property => (property === null || property === void 0 ? void 0 : property.propertyStatus) === PROPERTY_STATUS_ENUM.Active)) || [];
  };
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    propertySearchKey = _useState6[0],
    setPropertySearchKey = _useState6[1];
  const selectedProperty = newBillingActivated ? propertyId !== null && propertyId !== void 0 ? propertyId : (_currentCompany$portf5 = currentCompany.portfolios.find(portfolio => portfolio.id === selectedPortfolio)) === null || _currentCompany$portf5 === void 0 || (_currentCompany$portf5 = _currentCompany$portf5.properties.filter(property => (property === null || property === void 0 ? void 0 : property.propertyStatus) === PROPERTY_STATUS_ENUM.Active)[0]) === null || _currentCompany$portf5 === void 0 ? void 0 : _currentCompany$portf5.id : store.enrollResident.selectedProperty || propertyId;
  const setSelectedProperty = store.enrollResident.setSelectedProperty;
  const handlePortfolioChange = async event => {
    const handleChangePortfolioId = event.target.value;
    if (handleChangePortfolioId) {
      var _currentCompany$portf6;
      track(events.selected('Portfolio For Enrollment'));
      setSelectedPortfolio(handleChangePortfolioId);
      const selectedPortfolioActiveProperties = (_currentCompany$portf6 = currentCompany.portfolios.find(portfolio => portfolio.id === handleChangePortfolioId)) === null || _currentCompany$portf6 === void 0 ? void 0 : _currentCompany$portf6.properties.filter(property => (property === null || property === void 0 ? void 0 : property.propertyStatus) === PROPERTY_STATUS_ENUM.Active);
      if (!!(selectedPortfolioActiveProperties !== null && selectedPortfolioActiveProperties !== void 0 && selectedPortfolioActiveProperties.length)) {
        var _selectedPortfolioAct, _selectedPortfolioAct2;
        setSelectedProperty((_selectedPortfolioAct = selectedPortfolioActiveProperties[0]) === null || _selectedPortfolioAct === void 0 ? void 0 : _selectedPortfolioAct.id);
        await getUnits((_selectedPortfolioAct2 = selectedPortfolioActiveProperties[0]) === null || _selectedPortfolioAct2 === void 0 ? void 0 : _selectedPortfolioAct2.id);
      } else {
        setSelectedProperty('');
        store.enrollResident.assignSearchedUnits({
          response: []
        });
      }
      store.enrollResident.customSearch('');
      setSelectedUnit('');
      setPropertySearchKey('');
    }
  };

  // NOTE: this may cause looping in enrollment modal relates to LB-4830
  const fetchPortfolios = async () => {
    const resp = await store.portfolios.getPortfoliosDashboardAsync.run({
      storeCompany: true
    });
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      // setProperties(
      //   currentCompany?.portfolios
      //     ?.find(portfolio => portfolio.id === selectedPortfolio)
      //     ?.properties.filter(property => property?.propertyStatus === PROPERTY_STATUS_ENUM.Active) ??
      //     currentCompany?.portfolios?.find(
      //       portfolio =>
      //         !!portfolio.properties?.filter(property => property?.propertyStatus === PROPERTY_STATUS_ENUM.Active)
      //           ?.length
      //     )
      // );
    }
  };
  useEffect(() => {
    fetchPortfolios();
    // if (enablePortfolioSelect || newBillingActivated) fetchPortfolios();
    if (selectedProperty) {
      setSelectedProperty(selectedProperty);
      getUnits(selectedProperty);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId, selectedProperty]);
  const handlePropertyChange = async event => {
    if (event.target.value) {
      setActiveUnitName(undefined);
      track(events.selected('Property For Enrollment'));
      setSelectedProperty(event.target.value);
      setSelectedUnit('');
      setPropertySearchKey('');
      store.enrollResident.customSearch('');
      await getUnitsExtendedAsync.run({
        propertyId: event.target.value,
        search: '',
        statuses: [UNIT_STATUSES_NAMED.Vacant, UNIT_STATUSES_NAMED.ToBeVacantSoon]
      });
    }
  };
  const handleUnitChange = event => {
    setSelectedUnit(event.target.value);
    store.enrollResident.changeInUnitValue('unitId', event.target.value);
  };
  const handleUnitSearch = value => store.enrollResident.customSearch(value);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.enrollBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    marginBottom: "12px",
    variant: "h4"
  }, "Enroll in"), /*#__PURE__*/React.createElement(Grid, {
    columnSpacing: 10,
    container: true,
    rowSpacing: 10
  }, enablePortfolioSelect && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "portfolio-selector",
    label: t('Select portfolio'),
    labelId: "portfolio-selector-label",
    disabled: store.portfolios.getPortfoliosDashboardAsync.inProgress,
    onChange: handlePortfolioChange,
    onSearch: setPortfolioSearchKey,
    value: selectedPortfolio
  }, currentCompany.portfolios.filter(i => i.name.toLowerCase().includes(portfolioSearchKey.toLowerCase())).map(portfolio => /*#__PURE__*/React.createElement(MenuItem, {
    value: portfolio.id,
    key: portfolio.id
  }, portfolio.name))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    lg: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "property-selector",
    key: "property-selector-".concat(store.portfolios.getPortfoliosDashboardAsync.inProgress),
    label: !!((_getProperties = getProperties()) !== null && _getProperties !== void 0 && _getProperties.length) ? t('general.select_a_propery') : 'No properties found',
    labelId: "property-selector-label",
    disabled: ((_getProperties2 = getProperties()) === null || _getProperties2 === void 0 ? void 0 : _getProperties2.length) === 0 || store.portfolios.getPortfoliosDashboardAsync.inProgress,
    onChange: handlePropertyChange,
    onSearch: setPropertySearchKey,
    value: selectedProperty,
    onCloseExternal: () => setPropertySearchKey('')
  }, store.portfolios.getPortfoliosDashboardAsync.inProgress ? null : (_getProperties3 = getProperties()) === null || _getProperties3 === void 0 || (_getProperties3 = _getProperties3.filter(property => {
    var _property$propertyId;
    if ((_property$propertyId = property.propertyId) !== null && _property$propertyId !== void 0 ? _property$propertyId : property.id === selectedProperty) return true;
    const searchPhrase = new RegExp(propertySearchKey, 'gi');
    return propertySearchKey.length > 0 ? " ".concat(property.propertyAddress).search(searchPhrase) > 0 : true;
  })) === null || _getProperties3 === void 0 ? void 0 : _getProperties3.map(property => {
    var _property$propertyId2, _property$propertyId3;
    return (
      /*#__PURE__*/
      // NOTE: Need to improve store models
      React.createElement(MenuItem, {
        value: (_property$propertyId2 = property.propertyId) !== null && _property$propertyId2 !== void 0 ? _property$propertyId2 : property.id,
        key: (_property$propertyId3 = property.propertyId) !== null && _property$propertyId3 !== void 0 ? _property$propertyId3 : property.id
      }, property.propertyAddress)
    );
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    lg: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    disabled: initialUnits.length === 0 || store.portfolios.getPortfoliosDashboardAsync.inProgress || store.units.getUnitsExtendedAsync.inProgress,
    enableSearch: true,
    id: "unit-selector",
    label: !!(customSearchedUnits !== null && customSearchedUnits !== void 0 && customSearchedUnits.length) ? 'Select a unit' : 'No units found',
    labelId: "unit-selector-label",
    onChange: handleUnitChange,
    onSearch: handleUnitSearch,
    value: selectedUnit
  }, customSearchedUnits.map(unit => /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.menuItem,
    key: unit.id,
    value: unit.id
  }, t('general.unit'), " ", unit.name, ' ', /*#__PURE__*/React.createElement(Chip, {
    label: 'Vacant' + (unit.status === 'Vacant' ? '' : " since ".concat(moment(unit.availableFromDateOnly).format('L'))),
    variant: unit.status === 'Vacant' ? 'success' : 'info'
  }))))))), !selectedProperty || initialUnits.length > 0 || getUnitsExtendedAsync.inProgress ? null : /*#__PURE__*/React.createElement(Chip, {
    label: "There are no vacant units in the selected property",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "warning"
  }));
});